import { ArrowLeft, Search, Edit2, Check, LinkIcon } from "lucide-react";
import "./index.css";
import { useSelector, useDispatch } from "react-redux";
import { updateCart } from "../../../../slice/sellingCarts";
import { useState, useEffect } from "react";
import { minus, plus } from "../../../../components/ProductToSell";
import { X, Minus, Plus } from "lucide-react";

import "./ProductOverlay.css";
import SerialNumber from "../../../../components/productToSellCard/AddSerialNumber";

const ProductConfirmation = ({ whichCompToRender }) => {
  const [editProductModal, setEditProductModal] = useState(false);
  const [productToEdit, setProductToEdit] = useState(null);
  const [cartItemCopy, setCartItemCopy] = useState(null);
  const [searchString, setSearchString] = useState(null);
  const { cartItem, total, discount, vat, vatPercentage } = useSelector((state) => state.sellingCart);
  const { user } = useSelector((state) => state.webStoreUser);
  const { store } = useSelector((state) => state.store);
  const currency = user.userCountryCurrencySymbol ? user.userCountryCurrencySymbol : "#";
  console.log(vat, vatPercentage, "vat,vatPercentage in product confirmation");

  useEffect(() => {
    console.log(cartItem, "cartItem in product confirmation");

    setCartItemCopy(cartItem);
  }, [cartItem]);

  useEffect(() => {
    productToEdit && setEditProductModal(true);
  }, [productToEdit]);

  const formatPrice = (price) => `${currency}${price.toLocaleString()}`;

  console.log(total, "total in product confirmation");

  const subtotal = total;

  const totalToPay = Math.ceil(Number(subtotal) - Number(discount) + Number(vat));

  const getInitial = (name) => name.charAt(0).toUpperCase();

  const checklistSteps = [
    { id: 1, title: "Select product", completed: true },
    { id: 2, title: "Confirm Selected products", active: true },
    { id: 3, title: "Operation type and customer info", completed: false },
    { id: 4, title: "Confirmation", completed: false },
  ];

  return (
    <>
      <div className='product-confirmation-container'>
        <div className='product-confirmation-wrapper'>
          {/* Mobile Checklist - Horizontal */}
          <div className='mobile-checklist-container'>
            <div className='mobile-checklist-inner'>
              {checklistSteps.map((step, index) => (
                <div key={step.id} className='mobile-checklist-step'>
                  <div className={`mobile-step-circle ${step.completed ? "completed" : step.active ? "active" : "inactive"}`}>
                    {step.completed ? <Check className='icon medium' /> : <span>{step.id}</span>}
                  </div>
                  {index < checklistSteps.length - 1 && <div className={`mobile-step-connector ${step.completed ? "completed" : "inactive"}`} />}
                </div>
              ))}
            </div>
          </div>

          <div className='main-content-grid'>
            {/* Main Content - Full Left Side */}
            <div className='left-column'>
              {/* Scrollable Header Section */}
              <div className='header-section'>
                {/* Header */}
                {/*  <div className='header-nav'>
                      <button className='back-button'>
                        <ArrowLeft className='icon medium' />
                      </button>
                      <h1 className='page-title'>Confirm Selection</h1>
                    </div> */}

                {/* Search */}
                <div className='search-card'>
                  <div className='search-input-wrapper'>
                    <Search className='search-icon2' />
                    <input
                      value={searchString}
                      onChange={(e) => {
                        setSearchString(e.target.value);
                        let filteredProducts = cartItem.filter((product) => {
                          return product.name.toLowerCase().includes(e.target.value.toLowerCase());
                        });
                        setCartItemCopy(filteredProducts);
                      }}
                      type='text'
                      placeholder='Search product'
                      className='search-input'
                    />
                  </div>
                </div>
              </div>

              {/* Flexible Product List Container */}
              <div className='products-container'>
                <div className='products-card'>
                  {/* Desktop Table Header */}
                  <div className='desktop-table-header'>
                    <div className='table-header-grid'>
                      <div>Product</div>
                      <div>Unit Price</div>
                      <div>Sold quantity</div>
                      <div>Total</div>
                      <div>Edit</div>
                    </div>
                  </div>

                  {/* Scrollable Product Content */}
                  <div className='products-scroll-container'>
                    <div className='products-content'>
                      {/* Desktop Layout */}
                      <div className='desktop-products-list'>
                        {cartItemCopy?.map((product) => (
                          <div onClick={() => setProductToEdit(product)} key={product.id} className='desktop-product-row'>
                            <div className='product-info'>
                              <div className='product-avatar'>
                                <div className='product-initial-wrapper'>
                                  <span className='product-initial'>{getInitial(product.name)}</span>
                                </div>
                                {product.isSubUnitSold && (
                                  <span className='subUnitLink'>
                                    <LinkIcon size={10} />
                                  </span>
                                )}
                              </div>
                              <div>
                                {" "}
                                <span className='product-name'>{product.name}</span>
                                {product.serialNumber && (
                                  <p
                                    style={{
                                      fontSize: "11px",
                                      color: "rgb(106, 182, 249)",
                                      marginTop: "4px",
                                      fontStyle: "italic",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {`S/N: ${product.serialNumber}`}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className='product-price'>
                              {" "}
                              {currency}
                              {product.soldUnitPrice.toLocaleString()}
                            </div>
                            <div>
                              <span className='quantity-badge'>{product.soldQuantity}</span>
                            </div>
                            <div className='product-total'>
                              {currency}
                              {product.totalPrice.toLocaleString()}
                            </div>
                            <div>
                              <button className='edit-button'>
                                <Edit2 className='icon small' />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Mobile Layout */}
                      <div className='mobile-products-list'>
                        {cartItemCopy?.map((product) => (
                          <div onClick={() => setProductToEdit(product)} key={product._id} className='mobile-product-card'>
                            <div className='mobile-product-header'>
                              <div className='product-avatar'>
                                <div className='product-initial-wrapper'>
                                  <span className='product-initial'>{getInitial(product.name)}</span>
                                </div>
                                {product.isSubUnitSold && (
                                  <span className='subUnitLink'>
                                    <LinkIcon size={10} />
                                  </span>
                                )}
                              </div>
                              <div className='mobile-product-info'>
                                <h3 className='mobile-product-name'>{product.name}</h3>
                                <p className='mobile-product-price'>{formatPrice(product.soldUnitPrice)}</p>
                              </div>
                              <button className='edit-button'>
                                <Edit2 className='icon small' />
                              </button>
                            </div>
                            <div className='mobile-product-footer'>
                              <div className='mobile-quantity-section'>
                                <span className='mobile-quantity-label'>Qty:</span>
                                <span className='quantity-badge'>{product.soldQuantity}</span>
                              </div>
                              <div className='mobile-total-section'>
                                <p className='mobile-total-label'>Total:</p>
                                <div className='mobile-total-value'>{formatPrice(product.soldUnitPrice * product.soldQuantity)}</div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Sidebar - Desktop Only */}
            <div className='desktop-sidebar'>
              <div className='sidebar-card'>
                <div className='sidebar-content'>
                  <div className='sidebar-header'>
                    <h2 className='sidebar-title'>Sell product Checklist</h2>
                    <div className='sidebar-title-underline'></div>
                  </div>

                  <div className='desktop-checklist'>
                    {checklistSteps.map((step, index) => (
                      <div key={step.id} className='desktop-checklist-step'>
                        <div className='desktop-step-indicator'>
                          <div className={`desktop-step-circle ${step.completed ? "completed" : step.active ? "active" : "inactive"}`}>
                            {step.completed ? <Check className='icon medium' /> : <span>{step.id}</span>}
                          </div>
                          {index < checklistSteps.length - 1 && <div className={`desktop-step-connector ${step.completed ? "completed" : "inactive"}`} />}
                        </div>
                        <div className='desktop-step-text'>
                          <p className={`desktop-step-title ${step.active ? "active" : step.completed ? "completed" : "inactive"}`}>{step.title}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Pricing Breakdown */}
                  <div className='pricing-breakdown'>
                    <div className='pricing-card'>
                      <div className='pricing-row'>
                        <span className='pricing-label'>Subtotal:</span>
                        <span className='pricing-value'>{formatPrice(subtotal)}</span>
                      </div>
                    </div>

                    <div className='pricing-card'>
                      {store.isVATenabled ? (
                        <div className='pricing-row'>
                          <span className='pricing-label'>VAT ({vatPercentage}%):</span>
                          <span className='pricing-value'>{formatPrice(vat)}</span>
                        </div>
                      ) : (
                        <div className='pricing-row'>
                          <span className='pricing-label'>VAT:</span>
                          <span style={{ fontSize: "14px", color: "gray" }} className='pricing-value'>
                            VAT is disabled
                          </span>
                        </div>
                      )}
                    </div>

                    <div className='pricing-card'>
                      <div className='pricing-row'>
                        <span className='pricing-label'>Discount:</span>
                        <span className='pricing-value'>{formatPrice(discount)}</span>
                      </div>
                    </div>

                    <div className='pricing-card total'>
                      <div className='pricing-row'>
                        <span className='pricing-label total'>Total:</span>
                        <span className='pricing-value total'>{formatPrice(totalToPay)}</span>
                      </div>
                    </div>
                  </div>

                  <button onClick={() => whichCompToRender("ConfirmSelection")} className='next-button'>
                    Next
                  </button>
                  <button
                    onClick={() => whichCompToRender("SelectProduct")}
                    style={{
                      marginTop: "-16px",
                      color: "#2861E3",
                      background: "white",
                      border: "1px solidrgb(150, 182, 255)",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      justifyContent: "center",
                    }}
                    className='next-button'
                  >
                    <ArrowLeft className='icon medium' />
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Bottom Actions */}
        <div className='mobile-bottom-actions'>
          <div className='mobile-pricing-content'>
            <div className='mobile-pricing-row'>
              <span className='mobile-pricing-label'>Subtotal:</span>
              <span className='mobile-pricing-value'>{formatPrice(subtotal)}</span>
            </div>
            {store.isVATenabled ? (
              <div className='mobile-pricing-row'>
                <span className='mobile-pricing-label'>VAT({vatPercentage}%):</span>
                <span style={{ fontSize: "14px" }} className='mobile-pricing-value'>
                  {formatPrice(vat)}
                </span>
              </div>
            ) : (
              <div>
                <span style={{ fontSize: "12px", color: "gray" }}>VAT is disabled</span>
              </div>
            )}
            <div className='mobile-pricing-row'>
              <span className='mobile-pricing-label'>Discount:</span>
              <span className='mobile-pricing-value'>{formatPrice(discount)}</span>
            </div>
            <div className='mobile-pricing-row total'>
              <span className='mobile-pricing-label total'>Total:</span>
              <span className='mobile-pricing-value total'>{formatPrice(totalToPay)}</span>
            </div>
            <button onClick={() => whichCompToRender("ConfirmSelection")} className='next-button'>
              Next
            </button>
            <button
              onClick={() => whichCompToRender("SelectProduct")}
              style={{
                color: "#2861E3",
                background: "white",
                border: "1px solidrgb(150, 182, 255)",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                justifyContent: "center",
              }}
              className='next-button'
            >
              <ArrowLeft className='icon medium' />
              Go Back
            </button>
          </div>
        </div>
      </div>
      {
        editProductModal && (
          <ProductOverlay
            product={productToEdit}
            setOpenEditProduct={setEditProductModal}
            cartItem={cartItem}
            cartTotal={total}
            currency={currency}
            setProductToEdit={setProductToEdit}
            setCartItemCopy={setCartItemCopy}
            whichCompToRender={whichCompToRender} // Pass this prop to handle navigation
          />
        )

        /* <SelectedProduct
          product={productToEdit}
          setOpenEditProduct={setEditProductModal}
          cartItem={cartItem}
          cartTotal={total}
          currency={currency}
          setProductToEdit={setProductToEdit}
          setCartItemCopy={setCartItemCopy}
        /> */
      }
    </>
  );
};

export default ProductConfirmation;

export const ProductOverlay = ({ product, setOpenEditProduct, cartItem, cartTotal, currency, setProductToEdit, whichCompToRender }) => {
  const [unitPrice, setUnitPrice] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [totalPrice, setTotalPrice] = useState(null);
  const [serialNumber, setSerialNumber] = useState(product.serialNumber || "");

  let imageUrl = product?.productImage
    ? `${product?.productImage[0].split("/upload/")[0]}/upload/f_auto,q_auto,w_140/${product?.productImage[0].split("/upload/")[1]}`
    : "https://res.cloudinary.com/dq2tuqv1p/image/upload/v1697054861/inventory-manager/placeholders/product-placeholder_oqxvuk.png";
  const dispatch = useDispatch();

  useEffect(() => {
    if (product) {
      setQuantity(product.soldQuantity);
      setUnitPrice(product.soldUnitPrice);
      setTotalPrice(product.totalPrice);
    }
  }, []);

  useEffect(() => {
    setTotalPrice(parseInt(unitPrice) * parseInt(quantity));
  }, [unitPrice, quantity]);

  const controlQuantityInput = (e) => {
    if (parseInt(e.target.value) < 1) {
      e.target.value = 1;
      setQuantity(1);
    } else if (parseInt(e.target.value) > parseInt(product?.quantity) - parseInt(product?.damagedAmount)) {
      console.log("here is greated");
      e.target.value = parseInt(product?.quantity) - parseInt(product?.damagedAmount);
      setQuantity(e.target.value);
    } else if (isNaN(e.target.value) || !e.target.value) {
      setQuantity(product.soldQuantity || 1);
    } else {
      setQuantity(e.target.value);
    }
  };

  const removeFromCartFun = () => {
    let newCart = cartItem.filter((item) => item._id !== product._id);

    /* let selectedProductCart = {
        cart: newCart,
        total: cartTotal,
      };
      dispatch(updateCart(selectedProductCart)); */
    let newTotal = cartTotal - product.totalPrice;
    let updatedSellingCart = {
      cart: newCart,
      total: newTotal,
    };
    console.log(updatedSellingCart, "updatedSellingCart");

    dispatch(updateCart(updatedSellingCart));
    setOpenEditProduct(false);
    setProductToEdit(null);
    // if selling cart is empty, go back to previous paage
    if (newCart.length === 0) {
      whichCompToRender("SelectProduct");
    }
  };
  const unWantedInputs = ["e", "E", "+", "-", "e+", "E+", "e-", "E-", "+-", "-+"];

  /*  if (!isOpen) return null; */
  const confirmProduct = () => {
    let newCart = [...cartItem];
    let i = cartItem.indexOf(product);
    let updatedProduct = {
      ...product,
      totalPrice: (unitPrice ? unitPrice : product.soldUnitPrice) * quantity,
      soldUnitPrice: unitPrice ? unitPrice : product.soldUnitPrice,
      soldQuantity: quantity,
      serialNumber: serialNumber,
    };
    newCart[i] = updatedProduct;
    /* let newTotal = cartTotal - (product.totalPrice + updatedProduct.totalPrice); */
    let newTotal = newCart.reduce((acc, item) => {
      return acc + item.totalPrice;
    }, 0);
    let updatedSellingCart = {
      cart: newCart,
      total: newTotal,
    };
    console.log(updatedSellingCart, "updatedSellingCart");

    dispatch(updateCart(updatedSellingCart));
    setOpenEditProduct(false);
    setProductToEdit(null);
  };

  const allowDigits = (e) => {
    if (e.inputType?.startsWith("insert") && e.data && /[^0-9]/.test(e.data)) {
      e.preventDefault();
    }
  };
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return (
    <div className='product-overlay'>
      <div className='product-overlay-backdrop' onClick={() => setOpenEditProduct(false)} />
      <div className='product-overlay-content'>
        <div className='product-card'>
          {/* Product Image */}
          <div className='product-image'>
            <div className='product-placeholder'>
              {/* <div className='placeholder-icons'>
                <div className='placeholder-icon'></div>
                <div className='placeholder-icon'></div>
              </div> */}
              <img src={imageUrl.toString()} className='js7sfbsd88' />
            </div>
          </div>

          {/* Product Details */}
          <div className='product-details'>
            <div className='product-brand'>{product.brand}</div>
            <div className='product-name'>{product.name}</div>
            <div className='product-total'>
              Total{" "}
              <span className='total-amount'>
                {currency} {totalPrice?.toLocaleString()}
              </span>
            </div>
          </div>
          <div style={{ display: "flex", gap: "10px", alignItems: "center", flexDirection: "column", justifyContent: "space-between" }}>
            <div
              style={{
                padding: "6px 12px",
                background: unitPrice > product.costPrice ? "#dbeafe" : "#fee2e2",
                borderRadius: "8px",
                fontSize: "12px",
                fontWeight: "600",
                color: unitPrice > product.costPrice ? "#1e40af" : "#dc2626",
                whiteSpace: "nowrap",
                height: "fit-content",
              }}
            >
              {unitPrice > product.costPrice ? "↗ Profit" : "↘ Loss"}
            </div>
            <SerialNumber value={serialNumber} onChange={setSerialNumber} />
          </div>
        </div>

        {/* Price and Quantity Section */}
        <div className='price-quantity-section'>
          <div className='input-group'>
            <label className='input-label'>Unit Price</label>
            <div className='price-input-wrapper'>
              <span className='currency-symbol'>{currency} </span>
              <input
                key={isMobile ? "mobile" : "desktop"}
                type={isMobile ? "text" : "number"}
                inputMode='numeric' // shows numeric keyboard on mobile
                pattern={isMobile ? "[0-9]*" : undefined}
                onBeforeInput={isMobile ? allowDigits : undefined}
                value={unitPrice}
                onChange={(e) => {
                  const raw = e.target.value; // always something like "1234" or ""

                  if (unWantedInputs.includes(e.nativeEvent.data)) return;
                  if (raw === "") {
                    setUnitPrice("");
                    return;
                  }
                  // 🚫 If not a number, revert to previous valid product price
                  if (isNaN(raw)) {
                    setUnitPrice(product.soldUnitPrice);
                    return;
                  }
                  // ✅ Strip leading zeros and update
                  const cleanValue = Number(raw.replace(/^0+/, "") || "0");
                  setUnitPrice(cleanValue);
                }}
                onBlur={() => {
                  if (unitPrice === "" || unitPrice <= 0 || isNaN(unitPrice)) {
                    setUnitPrice(Number(product.unitPrice));
                  }
                }}
                className='price-input'
                placeholder={unitPrice?.toLocaleString()}
              />
              <div className='help-icon'>?</div>
            </div>
          </div>

          <div className='input-group'>
            <label className='input-label'>Quantity ({product.unit})</label>
            <div className='quantity-controls'>
              <button className='quantity-btn' onClick={() => setQuantity(quantity - 1 < 1 ? 1 : quantity - 1)} disabled={quantity <= 1}>
                <Minus className='quantity-icon' />
              </button>
              <input
                key={isMobile ? "mobile" : "desktop"}
                type={isMobile ? "text" : "number"}
                inputMode='numeric' // shows numeric keyboard on mobile
                pattern={isMobile ? "[0-9]*" : undefined}
                onBeforeInput={isMobile ? allowDigits : undefined}
                value={quantity}
                onChange={(e) => controlQuantityInput(e)}
                className='quantity-display'
                min='1'
              />
              <button
                className='quantity-btn'
                onClick={() =>
                  setQuantity(
                    quantity >= parseInt(product?.quantity) - parseInt(product?.damagedAmount)
                      ? parseInt(product?.quantity) - parseInt(product?.damagedAmount)
                      : quantity + 1
                  )
                }
              >
                <Plus className='quantity-icon' />
              </button>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className='action-buttons'>
          <button
            className='remove-btn'
            onClick={() => {
              removeFromCartFun();
            }}
          >
            Remove product
          </button>
          <button className='confirm-btn' onClick={confirmProduct}>
            Confirm product
          </button>
        </div>
      </div>
    </div>
  );
};
